const showdown = require('showdown');
const configHelper = require('../../config/index');

const makeHtml = (content) => {
    const converter = new showdown.Converter({
        noHeaderId: true,
        headerLevelStart: 3,
        strikethrough: true,
    });

    let htmlContent = converter.makeHtml(content);
    htmlContent = htmlContent.replaceAll(
        `/uploads`,
        `${configHelper.getConfig().cms.cmsUrl}/uploads`
    );
    return htmlContent;
};
export { makeHtml };
